/* istanbul ignore file */

import { Module } from 'vuex';

import { AppState } from '..';
import { prefixValues } from '@/helpers/util';
import { Restaurant } from '@/models';

export enum RetroCreditState {
  Landing = 'landing',
  ZipCodeEntry = 'zipcode-entry',
  RestaurantSelection = 'restaurant-selection',
  OrderDetails = 'order-details',
  Done = 'done',

  ReachedDailyLimit = 'reached-daily-limit',
  ReachedWeeklyLimit = 'reached-weekly-limit',
  ReachedMonthlyLimit = 'reached-monthly-limit',
  NotARewardsMember = 'not-a-rewards-member',
  DuplicateRequest = 'duplicate-request',
}

export const RETRO_CREDIT_COMPLETED_STATES = [
  RetroCreditState.Done,
  RetroCreditState.ReachedDailyLimit,
  RetroCreditState.ReachedWeeklyLimit,
  RetroCreditState.ReachedMonthlyLimit,
  RetroCreditState.NotARewardsMember,
  RetroCreditState.DuplicateRequest,
];

export interface RetroCreditOrderDetails {
  purchaseDate: string;
  checkNumber: string;
  purchaseTotal: string;
}

export interface RetroCreditModuleState {
  inProgress: boolean;
  state: RetroCreditState;
  restaurants: Restaurant[];
  selectedRestaurant: Restaurant | null;
  orderDetails: RetroCreditOrderDetails | null;
}

const MUTATION_NAMES = {
  SET_IN_PROGRESS: 'setInProgress',
  SET_STATE: 'setState',
  SET_RESTAURANTS: 'setRestaurants',
  SET_SELECTED_RESTAURANT: 'setSelectedRestaurant',
  SET_DETAILS: 'setDetails',
};

export const MUTATIONS = prefixValues(MUTATION_NAMES, 'retroCredit/');

export function makeRetroCreditModule(): Module<RetroCreditModuleState, AppState> {
  return {
    namespaced: true,
    state: {
      inProgress: false,
      state: RetroCreditState.Landing,
      restaurants: [],
      selectedRestaurant: null,
      orderDetails: null,
    },
    mutations: {
      [MUTATION_NAMES.SET_IN_PROGRESS](state, inProgress: boolean) {
        state.inProgress = inProgress;
      },
      [MUTATION_NAMES.SET_STATE](state, retroCreditState: RetroCreditState) {
        state.state = retroCreditState;
      },
      [MUTATION_NAMES.SET_RESTAURANTS](state, restaurants: Restaurant[]) {
        state.restaurants = restaurants;
      },
      [MUTATION_NAMES.SET_SELECTED_RESTAURANT](state, restaurant: Restaurant) {
        state.selectedRestaurant = restaurant;
      },
      [MUTATION_NAMES.SET_DETAILS](state, details: RetroCreditOrderDetails) {
        state.orderDetails = details;
      },
    },
  };
}
